import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FormField } from 'ui/formField';
import { RadioList } from 'ui/radioList';
import { Row, TopText } from 'ui/radioList/RadioListStyles';

export const StyledRadioList = styled(RadioList)`
  ${Row} {
    margin-bottom: 0;
  }
  ${TopText} {
    margin-top: 3px;
  } ;
`;

export const StyledFormField = styled(FormField)`
  && {
    margin: ${spacing.double} 0;
  }
`;
